import React from 'react'
import USTemplateDefault from 'src/components/template/us'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video="https://assets.fubo.tv/marketing/lp/videos/compressed/espnsportscenter.mp4"
    title="Watch SportsCenter on ESPN with Fubo"
    subtitle="Sports headlines, highlights, Top 10 and more"
    ctaText="Start Watching"
    networkSet="sports"
  />
)
